import { Box, IconButton, Typography } from "@mui/material";
import GoogleMaterialIcon from "components/google-icon";
import Image from "components/image";
import { AppointmentContext } from "context/AppointmentContext";
import Link from "next/link";
import { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { timemiliesToSpecificFormat } from "utils/format-time";

export default function CompanyInfo() {
    const { companyInformation, } = useContext(AppointmentContext);
    const { media_url, name, address_line1 = '', address_line2 = '', phone, email, country, timezone } = companyInformation || {};
    let { phonecode } = country || {}
    let phoneNumber = [phonecode, phone]?.filter(Boolean).join(' ')

    const { watch, setValue } = useFormContext()
    const showForm = watch("showForm");
    const appointmentDate = watch("date");
    let selectedSlot = watch('slot')


    return (
        <Box sx={{ display: "flex", height: "100%", flexDirection: "column", borderRight: { md: "2px solid #E5E7EB" }, }}>
            {!showForm &&
                <Box sx={{ p: { xs: 3, md: 4 }, borderBottom: { md: "2px solid #E5E7EB" }, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ flexDirection: "column", alignItems: "center", gap: 1, }}>
                        {!!media_url && <Image src={media_url} alt={name || 'company_logo'} sx={{ width: 100, height: 100 }} />}
                        <Box sx={{ mt: 1 }}>
                            <Typography variant="h6" color="text.secondary">{name}</Typography>
                            <Typography variant="body2" color="text.secondary">{`${address_line1} ${address_line2}`}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: 0.5 }}>
                        {!!phone &&
                            <Box sx={{ display: "flex", flexDirection: "row", alignItems: 'center', gap: 1 }}>
                                <GoogleMaterialIcon icon="call" filled sx={{ color: "text.disabled" }} />
                                <Typography variant="body2" component={Link} href={`tel:${phoneNumber}`} style={{ textDecoration: 'none' }} sx={{ color: 'text.secondary' }} >+{phoneNumber}</Typography>
                            </Box>
                        }
                        {!!email &&
                            <Box sx={{ display: 'flex', alignItems: "center", gap: 1 }}>
                                <GoogleMaterialIcon icon="mail" filled sx={{ color: "text.disabled" }} />
                                <Typography variant="body2" component={Link} href={`mailto:${email}`} style={{ textDecoration: 'none' }} sx={{ color: 'text.secondary' }} >{email}</Typography>
                            </Box>
                        }
                    </Box>
                </Box>
            }
            <Box sx={{ p: { xs: 3, md: 4 }, flex: 1, display: "flex", flexDirection: "column", justifyContent: 'space-between' }}>
                <Box >
                    {showForm && (
                        <IconButton variant='soft' color="primary" onClick={() => setValue('showForm', false, { shouldDirty: false })} sx={{ mb: 2 }}> <GoogleMaterialIcon icon="arrow_back" /> </IconButton>
                    )}
                    <Box display='flex' flexDirection='column'>
                        {showForm && <Typography variant="h6" color="text.primary">{name}</Typography>}
                        <Typography variant="subtitle1" color="text.secondary">Appointment Booking</Typography>
                    </Box>
                    {showForm &&
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 2 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                                <GoogleMaterialIcon icon="schedule" filled sx={{ color: "text.secondary" }} />
                                <Typography variant="body2" color="text.secondary" >{`${selectedSlot?.start_time_formatted} - ${selectedSlot?.end_time_formatted}`}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <GoogleMaterialIcon icon="event" sx={{ color: "text.secondary" }} />
                                <Typography variant="body2" color="text.secondary" >
                                    {`${timemiliesToSpecificFormat(appointmentDate, 'dddd MMMM DD')}, ${timemiliesToSpecificFormat(appointmentDate, 'YYYY')}`}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <GoogleMaterialIcon icon="globe" sx={{ color: "text.secondary" }} />
                                <Typography variant="body2" color="text.secondary" >{timezone}</Typography>
                            </Box>
                        </Box>
                    }

                    {!showForm && <Typography variant="body2" color="text.secondary" mt={2} >
                        Please select your preferred date and time, enter your contact and vehicle
                        details, and add any notes. Our team will review your request and confirm
                        your appointment shortly.
                    </Typography>}
                </Box>

                <Box sx={{ mt: 3 }} >
                    <Image
                        src="https://garagebox.s3.ap-south-1.amazonaws.com/web-assets/Group+640621.svg"
                        width={130}
                        height={130}
                        style={{ height: "auto" }}
                        alt="powered"
                    />
                </Box>
            </Box>
        </Box>
    );
}